import {ApiInterface} from '@/plugins/core/api/interface';

const apis: ApiInterface[] = [
  {
    name: 'config',
    actions: [
      {
        name: 'retrieve',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/component/retrieve_config',
      },
      {
        name: 'retrieve_gateway_additional_info',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/retrieve_gateway_additional_info',
      },
    ],
  },
  {
    name: 'tokens',
    actions: [
      {
        name: 'create_for_card',
        method: 'post',
        endpoint: '/api/js/v2/tokens/create_for_card',
        jsApi: true,
        recaptcha: true,
        skipBusinessEntityId: true,
      },
      {
        name: 'create_using_temp_token',
        method: 'post',
        endpoint: '/api/js/v2/tokens/create_using_temp_token',
        jsApi: true,
        recaptcha: true,
        skipBusinessEntityId: true,
      },
    ],
  },
  {
    name: 'gw_payment_intent',
    actions: [
      {
        name: 'get_gw_payment_method_config',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/payment_intents/get_gw_payment_method_config',
      },
    ],
  },
  {
    name: 'card_bin',
    actions: [
      {
        name: 'get_card_bin_data',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
        endpoint: '/api/internal/card_bin',
      },
    ],
  },
];

export default apis;
